import { doApi } from './apiClient';
import type { Pack } from '../types/models/pack';

export const apiGetPacks = (): Promise<{ data: Pack[] }> =>
  doApi('api/packs', 'GET');

export const apiCreatePack = (data: {
  name: string;
  expansion_id: number;
  cost: number;
  cards_per_pack: number;
  is_active: boolean;
}): Promise<Pack> =>
  doApi('api/packs', 'POST', data);

export const apiUpdatePack = (
  id: number,
  data: Partial<{
    name: string;
    expansion_id: number;
    cost: number;
    cards_per_pack: number;
    is_active: boolean;
  }>
): Promise<Pack> =>
  doApi(`api/packs/${id}`, 'PATCH', data);

export const apiDeletePack = (id: number): Promise<{ message: string }> =>
  doApi(`api/packs/${id}`, 'DELETE');
